module.exports = __webpack_public_path__ + "img/sCall.e76c7553.svg";